module.exports = __webpack_public_path__ + "img/buy0237.7ba27469.svg";